<template>
  <a-modal
    v-model="visible"
    title="操作首页轮播图"
    :width="720"
    @ok="submit"
    @cancel="close"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="[
            'title',
            { rules: [{ required: true, message: '请填写标题' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        label="展示图片"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <!--        <a-input-->
        <!--          v-decorator="['filePath',{rules:[{required:true,message:'请填写图片附件id'}]}]">-->
        <!--        </a-input>-->
        <a-upload
          v-decorator="[
            'filePath',
            {
              valuePropName: 'file',
              getValueFromEvent: uploadHead,
              rules: [{ required: true, message: '请选择展示图片' }]
            }
          ]"
          name="files"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :multiple="false"
          :action="uploadURL"
          :headers="headers"
        >
          <img
            v-if="form.getFieldValue('filePath')"
            class="userHead"
            :src="form.getFieldValue('filePath')"
            alt="userHead"
          />
          <div v-else>
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item
        label="显示位置 1:首页,2:分类"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="[
            'showPosition',
            { rules: [{ required: true, message: '请选择展示位置' }] }
          ]"
        >
          <a-select-option key="1" value="1">首页</a-select-option>
          <a-select-option key="2" value="2">分类</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="跳转链接地址"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'linkUrl',
            { rules: [{ required: true, message: '请填写跳转链接地址' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="[
            'ord',
            { rules: [{ required: true, message: '请填写排序' }] }
          ]"
        >
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { save } from "@/api/system/cmsBanner";
import pick from "lodash/pick";
import storage from "store";
import { USER_TOKEN } from "@/store/mutation-types";

export default {
  name: "CmsBannerColumnsModal",
  data() {
    return {
      modal: {},
      loading: false,
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 7 }, sm: { span: 24 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 24 } },
      //upload
      uploadURL: window._CONFIG["uploadURL"], //上传路径
      headers: { user_token: storage.get(USER_TOKEN) }
    };
  },
  methods: {
    //LOGO上传
    uploadHead({ file }) {
      if (file.status == "uploading") {
        return;
      }
      if (file.status == "done") {
        let path = file.response.result[0].filePath;
        return path;
      }
    },

    show(record) {
      this.visible = true;
      if (record) {
        record.showPosition = record.showPosition.toString();
        this.modal = record;
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.modal,
              "title",
              "filePath",
              "showPosition",
              "linkUrl",
              "ord"
            )
          );
        });
      }
    },
    submit() {
      this.form.validateFields((err, values) => {
        this.loading = true;
        if (!err) {
          let params = Object.assign(this.modal, values);
          save({ ...params }).then(res => {
            if (res.resultCode === 1) {
              this.$notification.success({ message: res.message });
              this.close();
              this.$emit("ok");
            } else {
              this.$notification.error({ message: res.message });
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    close() {
      this.title = "新增";
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>

<style></style>
